import { Extension } from '@tiptap/core';
import { appFor, toolbarFor } from './_get_menu_control';

const toggleVisibility = (toolbar, visible) => {
  const scrollY = window.scrollY;

  setTimeout(() => {
    requestAnimationFrame(() => {
      toolbar.classList.toggle('hide', !visible);

      if (visible) {
        window.scrollTo({ top: scrollY, behavior: 'auto' });
      }
    });
  }, 100);
};

const AutoHideToolbar = Extension.create({
  name: 'AutoHideToolbar',
  onCreate({ editor }) {
    editor.storage._app = appFor(editor);
    editor.storage._toolbar = toolbarFor(editor);
    toggleVisibility(editor.storage._toolbar, false);

    editor.storage._toggleOnMousedown = (event) => {
      const eventEditorApp = event.target.closest('[role="application"]');
      const visible = eventEditorApp === editor.storage._app;

      toggleVisibility(editor.storage._toolbar, visible);
    };
    document.addEventListener('mousedown', editor.storage._toggleOnMousedown);
  },
  // Destroying the editor (its controller disconnects, e.g. when jquery-modal moves a modal)
  // empties editor.storage, so a listener left behind would toggle an undefined toolbar.
  onDestroy() {
    document.removeEventListener('mousedown', this.editor.storage._toggleOnMousedown);
  },
  onFocus({ editor }) {
    toggleVisibility(editor.storage._toolbar, true);
  },
  onBlur({ editor, event }) {
    const target = event.relatedTarget;
    const eventApplication = target?.closest('[role="application"]');

    if (target && eventApplication !== editor.storage._app) {
      toggleVisibility(editor.storage._toolbar, false);
    }
  },
});

export default [AutoHideToolbar];
